export default {
      id: "ic_go-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_go",
      toString: function () {
        return this.url;
      }
    }